import { Text, BlockStack } from '@shopify/polaris';
import React, { useRef } from 'react';
import ReactQuill from 'react-quill';
import MagicUrl from 'quill-magic-url';
import 'react-quill/dist/quill.snow.css';

ReactQuill.Quill.register('modules/magicUrl', MagicUrl)

export default function InstructionsRichTextEditor({ value, helpText, setValue, title }) {
  const ref = useRef()

  console.log('value is', value)

  return (
    <BlockStack gap="100">
      <Text>{title}</Text>
      <ReactQuill
        modules={{
          magicUrl: true,
          toolbar: false /* [
            // [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
          ], */
        }} ref={ref} theme="snow" value={value} onChange={value => {
          const text = ref.current?.getEditor()?.getText()
          setValue(value)
        }} />
      <Text color="subdued">{helpText}</Text>
    </BlockStack>
  )
}
